import { render, staticRenderFns } from "./zoomPhoto.vue?vue&type=template&id=01c3fed9&scoped=true"
import script from "./zoomPhoto.vue?vue&type=script&lang=js"
export * from "./zoomPhoto.vue?vue&type=script&lang=js"
import style0 from "./zoomPhoto.vue?vue&type=style&index=0&id=01c3fed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c3fed9",
  null
  
)

export default component.exports